import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const chatAPI = {
  sendMessage: async (conversationId, message, includeAudio = false, isVoiceInput = false, audioMetrics = null) => {
    const payload = { 
      conversation_id: conversationId, 
      message, 
      include_audio: includeAudio,
      is_voice_input: isVoiceInput  // Flag for STT validation
    };
    
    // Add audio quality metrics if voice input
    if (isVoiceInput && audioMetrics) {
      payload.audio_confidence = audioMetrics.avgConfidence;
      payload.environment_type = audioMetrics.environmentType;
      payload.voice_metrics = {
        peakVolume: audioMetrics.peakVolume,
        avgVolume: audioMetrics.avgVolume,
        avgVoiceEnergyRatio: audioMetrics.avgVoiceEnergyRatio,
        noiseSuppressions: audioMetrics.noiseSuppressions,
        backgroundVoiceFiltered: audioMetrics.backgroundVoiceFiltered,
      };
    }
    
    const response = await axios.post(
      `${API}/chat/send`,
      payload,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Validate STT transcription before sending (optional pre-validation)
  validateSTT: async (transcription, conversationId = null, currentTopic = null) => {
    const response = await axios.post(
      `${API}/chat/validate-stt`,
      { transcription, conversation_id: conversationId, current_topic: currentTopic },
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  sendVoice: async (conversationId, audioBlob) => {
    const formData = new FormData();
    formData.append('audio_file', audioBlob, 'audio.webm');
    if (conversationId) {
      formData.append('conversation_id', conversationId);
    }
    const response = await axios.post(`${API}/chat/voice`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getConversations: async () => {
    const response = await axios.get(`${API}/chat/conversations`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  getConversation: async (conversationId) => {
    const response = await axios.get(`${API}/chat/conversation/${conversationId}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  createConversation: async (mode = 'free_chat', scenario = null) => {
    const response = await axios.post(
      `${API}/chat/conversation?mode=${mode}${scenario ? `&scenario=${scenario}` : ''}`,
      {},
      { headers: getAuthHeader() }
    );
    return response.data;
  },
};

export const personalityAPI = {
  get: async () => {
    const response = await axios.get(`${API}/personality`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  update: async (updates) => {
    const response = await axios.put(`${API}/personality`, updates, {
      headers: getAuthHeader()
    });
    return response.data;
  },
};

export const progressAPI = {
  get: async () => {
    const response = await axios.get(`${API}/progress`, {
      headers: getAuthHeader()
    });
    return response.data;
  },
};

export const scenariosAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/scenarios`);
    return response.data;
  },
};